import {
  AttributeConfigsResponse,
  BaseProductDetailResponse,
  BaseProductRetailersResponse,
  BaseProductSearchResponse,
  BaseProductsResponse,
  Category,
  EntityProductsResponse,
  PoolProduct,
  PoolProductsResponse,
  SelectedBaseProductSearchFilters,
} from '@/types/products'
import { StorageSerializers, useStorage } from '@vueuse/core'
import { defineStore } from 'pinia'
import { Reactive } from 'vue'

interface States {
  matchingEngineProducts: Ref<PoolProductsResponse | null>
  matchingEngineProductData: Ref<PoolProduct | null>
  brandProducts: Ref<EntityProductsResponse | null>
  retailerProducts: Ref<EntityProductsResponse | null>
  categories: Ref<Category[] | null>
  attributeConfigs: Ref<AttributeConfigsResponse | null>
  selectedBaseBottle: Ref<BaseProductDetailResponse['results'] | null>
  baseProductsSearchResults: Ref<BaseProductSearchResponse | null>
  baseProductsSearchFilters: Reactive<SelectedBaseProductSearchFilters | null>
  baseProducts: Ref<BaseProductsResponse | null>
  baseProductDetails: Ref<BaseProductDetailResponse | null>
  baseProductRetailers: Ref<BaseProductRetailersResponse | null>
  savedFilters: Ref<
    {
      id: number
      name: string
      filters: SelectedBaseProductSearchFilters
    }[]
  >
}

const SAVED_FILTERS_LOCAL_STORAGE_KEY_NAME = 'baseProductSearchSavedFilters'

export const useProductStore = defineStore('product', () => {
  const states: States = {
    matchingEngineProducts: ref(null),
    matchingEngineProductData: ref(null),
    brandProducts: ref(null),
    retailerProducts: ref(null),
    categories: ref(null),
    attributeConfigs: ref(null),
    selectedBaseBottle: ref(null),
    baseProductsSearchResults: ref(null),
    baseProductsSearchFilters: reactive({
      filterBy: 'all',
      isVerified: undefined,
      sort: {
        by: 'retailer_count',
        order: 'desc',
      },
      minScore: 30,
      category: {
        text: 'All',
        value: '',
      },
    }),
    baseProducts: ref(null),
    baseProductDetails: ref(null),
    baseProductRetailers: ref(null),
    savedFilters: useStorage(SAVED_FILTERS_LOCAL_STORAGE_KEY_NAME, [], undefined, {
      serializer: StorageSerializers.object,
    }),
  }

  const resetStore = () => {
    states.matchingEngineProducts.value = null
    states.matchingEngineProductData.value = null
    states.brandProducts.value = null
    states.retailerProducts.value = null
    states.categories.value = null
    states.attributeConfigs.value = null
    states.selectedBaseBottle.value = null
    states.baseProductsSearchResults.value = null
    states.baseProductsSearchFilters = {
      filterBy: 'all',
      isVerified: false,
      sort: {
        by: 'retailer_count',
        order: 'desc',
      },
      minScore: 0,
      category: null,
    }
    states.baseProducts.value = null
  }

  return {
    ...states,
    resetStore,
  }
})
